module.exports = __webpack_public_path__ + "img/top.58a89210.svg";